import Phaser from "phaser";

export class AudioGate {
  private scene: Phaser.Scene;
  private unlocked = false;
  private muted = false;
  private bgm?: Phaser.Sound.BaseSound;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    const unlock = () => this.unlock();
    scene.input.once("pointerdown", unlock);
    scene.input.keyboard?.once("keydown", unlock);
    scene.game.events.on(Phaser.Core.Events.BLUR, () => this.pauseAll());
    scene.game.events.on(Phaser.Core.Events.FOCUS, () => this.resumeAll());
  }

  isUnlocked() {
    return this.unlocked;
  }

  isMuted() {
    return this.muted;
  }

  setMuted(v: boolean) {
    this.muted = v;
    this.scene.sound.mute = v;
    if (v) this.pauseAll();
    else this.resumeAll();
  }

  unlock() {
    if (this.unlocked) return;
    this.unlocked = true;
    const ctx: AudioContext | undefined = (this.scene.sound as any)?.context;
    if (ctx && ctx.state === "suspended") {
      void ctx.resume().catch(() => {});
    }
  }

  playBgm(key: string, volume = 0.5, loop = true) {
    if (!this.unlocked || this.muted) return;
    if (!this.scene.cache.audio.exists(key)) {
      console.warn(`Audio key "${key}" not found in cache`);
      return;
    }
    // 既存のBGMを停止して破棄
    if (this.bgm) {
      this.bgm.stop();
      this.bgm.destroy();
      this.bgm = undefined;
    }
    this.bgm = this.scene.sound.add(key, { loop, volume });
    this.bgm.play();
  }

  stopBgm() {
    if (this.bgm) {
      this.bgm.stop();
      this.bgm.destroy();
      this.bgm = undefined;
    }
  }

  stopAll() {
    this.scene.sound.stopAll();
  }

  playSfx(key: string, volume = 0.7) {
    if (!this.unlocked || this.muted) return;
    if (!this.scene.cache.audio.exists(key)) {
      console.warn(`Audio key "${key}" not found in cache`);
      return;
    }
    this.scene.sound.play(key, { volume });
  }

  pauseAll() {
    if (this.muted) return;
    this.scene.sound.pauseAll();
  }

  resumeAll() {
    if (this.muted) return;
    this.scene.sound.resumeAll();
  }
}

